export default __webpack_public_path__ + "static/coindesk-e15e289f65a99cb18cd477c608ca988d.svg";